import M3Surface from "./M3Surface";
import M3Toolbar from "./M3Toolbar";
import SelectionActionBar from "./SelectionActionBar";
import styles from "./m3.module.css";

/**
 * Standard table card: title + search + filters + actions toolbar, an optional selection bar
 * and message, the grid itself, and an optional footer.
 *
 * @param {string} title - left-aligned table title
 * @param {string} subtitle
 * @param {React.ReactNode} leading - extra content beside the title (e.g. a SegmentedButton)
 * @param {string} search - controlled search value
 * @param {function} onSearchChange - omit to hide the search field
 * @param {React.ReactNode} filters
 * @param {React.ReactNode} actions - right-aligned toolbar buttons
 * @param {object} selection - SelectionActionBar props ({ count, onClear, actions, noun })
 * @param {React.ReactNode} message - e.g. a Banner shown above the grid
 * @param {React.ReactNode} footer
 */
const DataTableCard = ({
  title,
  subtitle,
  leading,
  search,
  onSearchChange,
  searchPlaceholder,
  filters,
  actions,
  selection,
  message,
  footer,
  children,
  elevated = false,
  className = "",
  style,
}) => {
  const titleBlock = (title || subtitle || leading) && (
    <>
      {(title || subtitle) && (
        <div className={styles.cardTitles}>
          {title && <h2 className={styles.cardTitle}>{title}</h2>}
          {subtitle && <p className={styles.cardSubtitle}>{subtitle}</p>}
        </div>
      )}
      {leading}
    </>
  );

  return (
    <M3Surface elevated={elevated} className={className} style={style}>
      <M3Toolbar
        leading={titleBlock}
        search={search}
        onSearchChange={onSearchChange}
        searchPlaceholder={searchPlaceholder}
        filters={filters}
        actions={actions}
      />
      {selection && <SelectionActionBar {...selection} />}
      {message && <div className={styles.cardMessage}>{message}</div>}
      <div className={styles.cardBody}>{children}</div>
      {footer && <div className={styles.cardFooter}>{footer}</div>}
    </M3Surface>
  );
};

export default DataTableCard;
